import Redemptions from "@/models/loyaltyPanel/Redemptions";

export default {
    namespaced: true,

    state: () => ({
        suppliers: [],
        gifts: [],
        allGifts: [],
        exportedFile: null,
        cancelGiftData: {},
        vouchers: [],
        exportedVoucher: null
    }),

    mutations: {
        setSuppliers(state, payload) {
            state.suppliers = payload;
        },

        setGifts(state, payload) {
            state.gifts = payload;
        },

        setCancelGiftData(state, payload) {
            state.cancelGiftData = payload;
        },

        setAllGifts(state, payload) {
            state.allGifts = payload;
        },

        setExportedFile(state, payload){
            state.exportedFile = payload
        },

        setVouchers(state, payload) {
            state.vouchers = payload;
        },

        setExportedVoucher(state, payload){
            state.exportedVoucher = payload
        }
    },

    actions: {
        async fetchRedemptions({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                
                let query = "?page=" + body.page

                if(body.query){
                    query += "&q=" + body.query
                }

                if(body.status){
                    query += "&status=" + body.status
                }

                if(body.supplier_id){
                    query += "&store_supplier_id=" + body.supplier_id
                }

                const { data } = await Redemptions.get(query);
                const { transactions, pagination } = data.data;
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setGifts", transactions);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async fetchVouchers({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Redemptions.getVouchers(query);
                const { transactions, pagination } = data.data;
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setVouchers", transactions);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async fetchAllGifts({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Redemptions.getAllGifts(query);
                const { pending_gifts, pagination } = data.data;
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setAllGifts", pending_gifts);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getSuppliers({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await Redemptions.getSuppliers();
                const suppliers = data.data;
                commit("setSuppliers", suppliers);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getExportedFileStatus({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.getExportedFileStatus()

                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportFile({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.exportFile()

                commit("setExportedFile", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await Redemptions.deleteExportedFile(id)

                commit("setExportedFile", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async getExportedVoucherStatus({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.getExportedVoucherStatus()

                commit("setExportedVoucher", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportVoucher({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.exportVoucher()

                commit("setExportedVoucher", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedVoucher({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await Redemptions.deleteExportedVoucher(id)

                commit("setExportedVoucher", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        
        async cancelGift({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                await Redemptions.cancelGift(id)

                commit("setCancelGiftData", {})
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        
        async getExportedAllVouchersStatus({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.getExportedAllVouchersStatus()

                commit("setExportedVoucher", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportAllVouchers({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Redemptions.exportAllVouchers()

                commit("setExportedVoucher", data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedAllVouchers({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });
                
                await Redemptions.deleteExportedAllVouchers(id)

                commit("setExportedVoucher", null)
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
    }
};
